export const FIELD_TYPES = {
  boolean: "boolean",
  integer: "integer",
  string: "string"
};
